import profile from './profile'
import rekeningBank from './rekening-bank'
import ekspedisi from './ekspedisi'
import pin from './pin'
import paymentSetting from './payment-setting'
import paymentKomchat from './payment-komchat'

export default [
  ...profile, ...rekeningBank, ...ekspedisi, ...pin, ...paymentSetting, ...paymentKomchat,
]
